export default __webpack_public_path__ + "static/media/Patrol.66fe3f89.png";